export default {"src":"/_next/static/media/OpenEBS.55791eaa.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};